import React from 'react';
import type { SingleValueProps } from 'react-select';
import { components } from 'react-select';
import * as styles from './SeriesSelectValue.module.scss';
import SVGIcon from '../../components/SVGIcon';
import seriesIcon from '../../icons/prefilled/16x16/series.svg';

const SeriesSelectValue = <
  Option extends { series: { name: string }; isDisabled: boolean },
>(
  props: SingleValueProps<Option, false>,
) => (
  <components.SingleValue {...props}>
    <div className={styles.container}>
      <SVGIcon size={14} className={styles.icon}>
        {seriesIcon}
      </SVGIcon>
      {props.data.series.name}
    </div>
  </components.SingleValue>
);

export default SeriesSelectValue;
